import { Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { AccountInfoLabel, BoxFlex, ClockIcon } from '@woovi/ui';
import { convertToMoney } from '@woovi/utils';

import type { PaymentActiveInstallmentScheduled_charge$key } from './__generated__/PaymentActiveInstallmentScheduled_charge.graphql.ts';
import PaymentLinkAdditionalInfo from '../../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentLinkComment from '../../paymentLink/PaymentLinkComment.tsx';
import PaymentLinkTransactionDetails from '../../PaymentLinkTransactionDetails.tsx';

import type { ReactNode } from 'react';

type PaymentActiveInstallmentScheduledProps = {
  charge: PaymentActiveInstallmentScheduled_charge$key;
};

const PaymentActiveInstallmentScheduled = (
  props: PaymentActiveInstallmentScheduledProps,
): ReactNode => {
  const theme = useTheme();
  const { t } = useTranslation();
  const charge = useFragment<PaymentActiveInstallmentScheduled_charge$key>(
    graphql`
      fragment PaymentActiveInstallmentScheduled_charge on Charge {
        id
        brCode
        identifier
        company {
          nameFriendly
          logo {
            url(fitIn: true)
          }
          projectType
          taxID {
            taxID
          }
        }
        valueWithDiscount
        ...PaymentLinkComment_charge
        ...PaymentLinkAdditionalInfo_charge
        ...PaymentLinkTransactionDetails_charge
      }
    `,
    props.charge,
  );

  return (
    <BoxFlex
      sx={{
        flexDirection: 'column',
        gap: '20px',
        mt: '20px',
      }}
    >
      <BoxFlex sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <ClockIcon color={theme.palette.tertiary.main} />
      </BoxFlex>
      <Typography
        variant={'h2'}
        sx={{ fontSize: '22px', fontWeight: 'bold', textAlign: 'center' }}
      >
        {t('Installments in Process')}
      </Typography>
      <PaymentLinkComment charge={charge} />

      <AccountInfoLabel
        label={t('Value')}
        text={convertToMoney(charge.valueWithDiscount)}
      />
      <BoxFlex
        sx={{
          flexDirection: 'column',
        }}
      >
        <PaymentLinkTransactionDetails charge={charge} />
        <PaymentLinkAdditionalInfo charge={charge} />
      </BoxFlex>
    </BoxFlex>
  );
};

export default PaymentActiveInstallmentScheduled;
